<template>
  <div>
    <v-breadcrumbs class="systock-breadcrump">
      <v-breadcrumbs-item :title="breadcrumb">
        {{ breadcrumb }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-tabs centered class="wkf-configuracao">
      <v-tab @click="tab = 1">
        <v-icon left>mdi-format-list-checkbox</v-icon>
        Item de Análise
      </v-tab>
      <v-tab @click="tab = 2">
        <v-icon left>mdi-account-group</v-icon>
        Controle de grupo
      </v-tab>
      <v-tab-item>
        <Item />
      </v-tab-item>
      <v-tab-item>
        <ControleGrupo :atualizar="tab" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import Item from "./Item";
import ControleGrupo from "./ControleGrupo";

export default {
  name: "WKFConfiguracao",
  components: {
    Item,
    ControleGrupo
  },
  data() {
    return {
      tab: "",
      breadcrumb: "WORKFLOW / CONFIGURAÇÃO / ITEM DE ANÁLISE"
    };
  },
  watch: {
    tab() {
      if (this.tab == 1)
        this.breadcrumb = "WORKFLOW / CONFIGURAÇÃO / ITEM DE ANÁLISE";
      else if (this.tab == 2)
        this.breadcrumb = "WORKFLOW / CONFIGURAÇÃO / CONTROLE DE GRUPO";
      else if (this.tab == 3)
        this.breadcrumb = "WORKFLOW / CONFIGURAÇÃO / AUTORIZAÇÃO";
    }
  }
};
</script>
<style>
.wkf-configuracao .v-icon.mdi-pencil:hover {
  color: blue;
}
.wkf-configuracao .v-icon.mdi-delete:hover {
  color: red;
}
.wkf-configuracao .input-descricao input {
  text-transform: uppercase;
}

.table-wkf-resposivo .v-data-table__wrapper {
  height: calc(100vh - 260px) !important;
}

.systock-breadcrump {
  background-color: #7979790a;
  height: 2.5em;
}
.wkf-configuracao .v-btn:not(.v-btn--round).v-size--default {
  height: 40px;
}
.wkf-configuracao .v-data-footer__select .v-select {
  margin: 4px 0 6px 16px !important;
}
.wkf-configuracao .v-data-table .v-toolbar__content {
  border-bottom: 1px solid #e0e0e0;
}
.wkf-configuracao .v-data-table--fixed-header .v-data-footer {
  margin-right: 0;
  padding-right: 16px;
}

.wkf-configuracao .v-tabs .v-tabs-bar {
  background-color: #7979790a !important;
}

.v-tabs-bar__content {
  border-bottom: 1px solid #f7f1f1;
  border-top: 1px solid #f7f1f1;
}

.v-card__actions {
  border-top: 1px solid #e0e0e0;
}
</style>
